import React from 'react';
import { ButtonProps } from '../../modules/types';
import './Button.scss';
import { Link } from 'react-router-dom';
const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  onClick,
  href,
  className = '',
  type = 'button'
}) => {
  const buttonClass = (variant as string) !== "see-more-button" ? `btn btn--${variant} btn--${size} ${loading ? 'btn--loading' : ''} ${className}` : 'see-more-button ' + className;
 
  const buttonContent = (
    <>
      {loading && <span className="btn__spinner" />}
      <span className={loading ? 'btn__text--hidden' : 'btn__text'}>
        {children}
      </span>
    </>
  );

  if (href && !disabled) {
    
    return (
      <Link to={href} className={buttonClass}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <button
      className={buttonClass}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
    >
      {buttonContent}
    </button>
  );
};

export default Button;